class LocalStorageService {
  static store(key, data) {
    if (!window.JSON || !key) {
      return false;
    }

    // Accessing/writing window.localStorage can throw (Safari Private Browsing,
    // sandboxed webviews, blocked site data, quota exceeded). Fail soft so a
    // storage-restricted browser degrades gracefully instead of crashing.
    try {
      const storage = window.localStorage;

      if (!storage) {
        return false;
      }

      const serializedData = typeof data === 'string' ? data : JSON.stringify(data);

      storage.setItem(key, serializedData);

      return true;
    } catch (err) {
      return false;
    }
  }

  static retrieve(key) {
    if (!window.localStorage || !window.JSON || !key) {
      return null;
    }

    const item = localStorage.getItem(key);

    if (!item) {
      return null;
    }

    try {
      return JSON.parse(item);
    } catch (err) {
      return item;
    }
  }

  static remove(key) {
    if (!window.localStorage || !window.JSON || !key) {
      return false;
    }

    if (!this.retrieve(key)) {
      return false;
    }

    localStorage.removeItem(key);

    return true;
  }
}

export default LocalStorageService;
